import { render, staticRenderFns } from "./PieGraph.vue?vue&type=template&id=96151c0a&scoped=true&"
import script from "./PieGraph.vue?vue&type=script&lang=js&"
export * from "./PieGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96151c0a",
  null
  
)

export default component.exports